import type { RequestFn } from '../http';

export interface JibbleSettings {
  enabled: boolean;
  activityId: string | null;
  timeZone: string;
  credentialsSet: boolean;
  encryptionAvailable?: boolean;
}

export interface JibbleSaveBody {
  enabled?: boolean;
  activityId?: string | null;
  timeZone?: string;
  clientId?: string;
  clientSecret?: string;
  clearCredentials?: boolean;
}

export function createJibbleApi(request: RequestFn) {
  return {
    async getJibbleSettings() {
      return request<{ jibble: JibbleSettings }>('/admin/jibble');
    },
    async saveJibbleSettings(body: JibbleSaveBody) {
      return request<{ jibble: JibbleSettings }>('/admin/jibble', {
        method: 'PUT',
        body: JSON.stringify(body),
      });
    },
    async testJibbleConnection() {
      return request<{ ok: boolean; peopleCount: number | null; error: string | null }>(
        '/admin/jibble/test',
        { method: 'POST' },
      );
    },
  };
}
